import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { clamp } from '../../../utils/clamp.mjs';
import { number, alpha } from '../numbers/index.mjs';
import { sanitize } from '../utils.mjs';
import { isColorString, splitColor } from './utils.mjs';
var clampRgbUnit = function clampRgbUnit(v) {
  return clamp(0, 255, v);
};
var rgbUnit = _objectSpread(_objectSpread({}, number), {}, {
  transform: function transform(v) {
    return Math.round(clampRgbUnit(v));
  }
});
var rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: function transform(_ref) {
    var red = _ref.red,
      green = _ref.green,
      blue = _ref.blue,
      _ref$alpha = _ref.alpha,
      alpha$1 = _ref$alpha === void 0 ? 1 : _ref$alpha;
    return "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};
export { rgbUnit, rgba };